module.exports = __webpack_public_path__ + "img/error.fdeae9aa.png";